"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryBrowserAesEncryptionService = void 0;

var _utils = require("./utils");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var loadBrowserAesKey = function loadBrowserAesKey(rawKey) {
  return window.crypto.subtle.importKey('raw', rawKey, 'AES-GCM', true, ['encrypt', 'decrypt']);
};

var provider = 'BROWSER';

var createKey = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var algorithm, key, exportedKey, iv;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            algorithm = {
              name: 'AES-GCM',
              length: 256
            };
            _context.next = 3;
            return window.crypto.subtle.generateKey(algorithm, true, ['encrypt', 'decrypt']);

          case 3:
            key = _context.sent;
            _context.next = 6;
            return window.crypto.subtle.exportKey('raw', key);

          case 6:
            exportedKey = _context.sent;
            iv = window.crypto.getRandomValues(new Uint8Array(16));
            return _context.abrupt("return", {
              key: exportedKey,
              iv: iv.buffer
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createKey() {
    return _ref.apply(this, arguments);
  };
}();

var aesToKeyId = function aesToKeyId(aesKey) {
  var b64AesKey = (0, _utils.bufferToBase64)(aesKey.key);
  var b64AesIv = (0, _utils.bufferToBase64)(aesKey.iv);
  return "".concat(b64AesKey, ".").concat(b64AesIv);
};

var keyIdToAes = function keyIdToAes(keyId) {
  var aesParts = keyId.split('.');
  var aes = {
    key: (0, _utils.base64ToBuffer)(aesParts[0]),
    iv: (0, _utils.base64ToBuffer)(aesParts[1])
  };
  return aes;
};

var encrypt = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(aesKey, plainText) {
    var browserAesKey, encrypted;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return loadBrowserAesKey(aesKey.key);

          case 2:
            browserAesKey = _context2.sent;
            _context2.next = 5;
            return window.crypto.subtle.encrypt({
              name: 'AES-GCM',
              iv: aesKey.iv
            }, browserAesKey, // eslint-disable-next-line node/no-unsupported-features/node-builtins
            new window.TextEncoder().encode(plainText).buffer);

          case 5:
            encrypted = _context2.sent;
            return _context2.abrupt("return", (0, _utils.bufferToBase64)(encrypted));

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function encrypt(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

var decrypt = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(aesKey, cipherText) {
    var browserAesKey, decrypted;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return loadBrowserAesKey(aesKey.key);

          case 2:
            browserAesKey = _context3.sent;
            _context3.next = 5;
            return window.crypto.subtle.decrypt({
              name: 'AES-GCM',
              iv: aesKey.iv
            }, browserAesKey, (0, _utils.base64ToBuffer)(cipherText));

          case 5:
            decrypted = _context3.sent;
            return _context3.abrupt("return", Promise.resolve(new window.TextDecoder().decode(decrypted)));

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function decrypt(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

var BasisTheoryBrowserAesEncryptionService = {
  provider: provider,
  createKey: createKey,
  aesToKeyId: aesToKeyId,
  keyIdToAes: keyIdToAes,
  encrypt: encrypt,
  decrypt: decrypt
};
exports.BasisTheoryBrowserAesEncryptionService = BasisTheoryBrowserAesEncryptionService;